import { useEffect, useState } from 'react';

export default function SocialLink(props) {
  const [src, setSrc] = useState('');
  const [defaultImage, setDefaultImage] = useState('');
  const [hoverImage, setHoverImage] = useState('');

  useEffect(() => {
    const loadImage = async (imageName) => {
      const image = await import(`assets/images/${imageName}.svg`);

      return image.default;
    };

    const initImages = async () => {
      const defaultImage = await loadImage(props.image);
      const hoverImage = await loadImage(props.hoverImage);

      return { defaultImage, hoverImage };
    }
 
    initImages().then(({ defaultImage, hoverImage }) => {
      setSrc(defaultImage);
      setDefaultImage(defaultImage);
      setHoverImage(hoverImage);
    });
  }, [props.image, props.hoverImage]);

  return (
    <li>
      <a 
        href={props.link}
        target="_blank"
        rel="noreferrer"
        onMouseEnter={() => { setSrc(hoverImage) }} 
        onMouseLeave={() => { setSrc(defaultImage) }}
        onFocus={() => { setSrc(hoverImage) }}
        onBlur={() => { setSrc(defaultImage) }}
        aria-label={props.title}>
        {defaultImage && <img src={src} alt='' width={32} height={32} />}
      </a>
    </li>
  );
}
